<template>
	<b-modal
		hide-footer
		no-close-on-backdrop
		centered
		:title="titleModal"
		size="xlg"
		v-model="isActive"
		@hidden="handleHidden"
		scrollable
	>
		<div class="container-modal-line px-1" style="max-height: 80vh">
			<div class="container-btns">
				<div class="pagination">
					<p @click="setPage(pa)" class="pages" v-for="(pa, index) in arrayPages" :key="index">{{ pa }}</p>

					<p class="active" :style="{ left: `${(page - 1) * 30}px` }">{{ page }}</p>
				</div>
			</div>
			<div class="container-line">
				<div class="container-scroll" :style="{ height: `${maxHeightContainer}px` }">
					<div class="line" :style="{ marginTop: `${maxHeight}px` }">
						<div class="first-specimen">
							<p>Aux</p>
							<div class="container-specimen">
								<img
									onerror="this.src='/rooster/rooster.jpg'"
									class="img-specimen"
									:src="specimen.image ? specimen.image : '/rooster/rooster.jpg'"
									:alt="specimen.plate"
								/>
								<div class="info">
									<p class="alias">{{ specimen.alias || "" }}</p>
									<p class="plate">{{ specimen.plate || "" }}</p>
								</div>
							</div>
						</div>
						<template v-for="(day, index) in lines">
							<div :key="index" class="day">
								<div class="container-date">
									<div class="circle">
										<FeatherIcon class="text-primary" icon="CheckIcon" size="24" />
									</div>
									<div class="day-text" :class="[index % 2 != 0 ? 'day-text-bottom' : '']">
										<p>{{ getDay(day.date) }}</p>
									</div>
									<div class="items" :class="[index % 2 == 0 ? 'item-top' : '']">
										<TypeLineItem
											class=""
											:item="item"
											v-for="(item, indexI) in day.actions"
											:key="indexI"
										>
											<!-- {{ item.action }} -->
										</TypeLineItem>
									</div>
								</div>
								<div
									class="line-vertical-line"
									:style="{ height: `${day.actions.length * 41 + 25}px` }"
									:class="[index % 2 != 0 ? 'line-vertical-line-top' : '']"
								></div>
							</div>
						</template>
						<div class="circle-last">
							<FeatherIcon
								@click="
									page++
									setPage(page)
								"
								v-if="totalPages != page"
								class="text-white cursor-pointer"
								icon="ChevronRightIcon"
								size="24"
								v-b-tooltip.hover
								title="Siguiente pagina"
							/>
							<div v-else style="height: 24px; width: 24px; background: #fff; border-radius: 50%">
								<!-- <FeatherIcon class="bg-white" icon="CircleIcon" size="24b" /> -->
							</div>
						</div>
						<div class="bars"></div>
					</div>
				</div>
			</div>

			<h4 v-if="frequentVitamins.length > 0" class="font-weight-bolder text-primary mb-2">
				Suplementos recurrentes:
			</h4>

			<div v-if="frequentVitamins.length > 0" class="table-events-recurrent">
				<div class="container-days">
					<p></p>
					<p>Lunes</p>
					<p>Martes</p>
					<p>Miércoles</p>
					<p>Jueves</p>
					<p>Viernes</p>
					<p>Sábado</p>
					<p>Domingo</p>
				</div>
				<div class="body-table">
					<div
						v-if="frequentVitamins.length > 0"
						class="container-events-recurrent"
						v-for="(vit, indexV) in frequentVitamins"
						:key="indexV"
					>
						<div class="cell">
							<div class="container-event">
								<div class="circle">
									<svg
										width="27"
										height="20"
										viewBox="0 0 27 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M20.307 10.2364L20.307 10.2364C19.4994 10.1383 18.7019 10.0439 17.894 9.94831C17.125 9.85729 16.3467 9.76516 15.5413 9.6677C15.6745 9.50911 15.8064 9.35369 15.9365 9.20036C16.362 8.69896 16.7685 8.21995 17.1392 7.7258C18.6384 5.76283 18.3465 3.04073 16.4911 1.4661C14.6376 -0.10691 11.8055 0.0243213 10.1791 1.88298C7.43989 5.01185 4.7599 8.1759 2.09229 11.3511L2.09205 11.3513C0.782654 12.9177 0.773287 15.1767 1.93134 16.8101L1.93158 16.8105C3.11062 18.4636 5.22403 19.2417 7.1161 18.4433C8.07398 18.0442 8.90598 18.0308 9.91744 18.1703L9.91761 18.1703C12.5078 18.5246 15.0992 18.8265 17.6889 19.1282C18.9829 19.279 20.2764 19.4297 21.5691 19.5869L21.5695 19.587C24.0279 19.879 26.3244 18.2368 26.716 15.8626L26.7161 15.8621C27.1304 13.303 25.5067 11.0069 22.9463 10.5679L22.945 10.5677C22.3232 10.4669 21.6936 10.3956 21.0706 10.325C20.8146 10.296 20.5598 10.2671 20.307 10.2364ZM2.58933 14.8719L2.58912 14.871C2.36287 13.9208 2.53267 13.0259 3.14886 12.275C4.13068 11.1003 5.12532 9.93893 6.13852 8.75586C6.45668 8.38435 6.77668 8.01071 7.09868 7.63385C8.00711 8.40383 8.89844 9.16333 9.78247 9.91662C10.4872 10.5171 11.1872 11.1136 11.8876 11.7084C11.8875 11.7088 11.8874 11.7093 11.8872 11.7097C11.8858 11.7148 11.8845 11.7193 11.8833 11.7231C11.881 11.7309 11.8792 11.736 11.8781 11.7389L11.8774 11.7398C11.5088 12.1726 11.1426 12.6069 10.7766 13.0409C9.86306 14.1241 8.95122 15.2054 8.0086 16.2574L8.00842 16.2576C7.16093 17.2068 6.08593 17.5318 4.84198 17.2039L4.84172 17.2038C3.63368 16.8877 2.87204 16.0932 2.58933 14.8719ZM13.8892 9.42851C13.5357 9.83741 13.1797 10.2492 12.8245 10.6686C11.4884 9.51992 10.1664 8.39256 8.8353 7.25747C8.56175 7.0242 8.28782 6.7906 8.0133 6.55642C8.28994 6.23293 8.56287 5.91071 8.83412 5.59047C9.6412 4.63765 10.4334 3.70242 11.2638 2.80351L11.265 2.80218C12.3987 1.54497 14.3008 1.47164 15.6248 2.58052C16.8412 3.60558 17.0966 5.52072 16.0992 6.78708L16.0989 6.78744C15.3959 7.68562 14.6483 8.55038 13.8892 9.42851ZM8.71771 5.49582C8.4469 5.81553 8.17469 6.1369 7.89919 6.45907L16.217 6.87989C17.2674 5.54618 16.996 3.53971 15.7213 2.46567C14.3404 1.309 12.3457 1.37981 11.1536 2.70172C10.3208 3.60319 9.52552 4.54212 8.71771 5.49582ZM25.3452 15.4882L25.3451 15.4888C25.1315 17.1757 23.5783 18.3831 21.8517 18.1913L21.8457 18.1906C20.2783 18.0075 18.7108 17.8245 17.0681 17.6306C17.1326 17.0828 17.1971 16.5383 17.2614 15.9955C17.4443 14.4523 17.6256 12.9221 17.8012 11.3639C18.5619 11.4416 19.2918 11.5197 20.011 11.6082L20.0112 11.6083C20.243 11.6364 20.4751 11.6637 20.7072 11.6911C21.3528 11.767 21.9988 11.843 22.6392 11.9382L22.6402 11.9383C24.3879 12.1864 25.5707 13.7636 25.3452 15.4882ZM11.9627 13.8599L11.9635 13.8589C12.2135 13.5693 12.4597 13.2783 12.7054 12.9879C13.1945 12.4098 13.6814 11.8344 14.1908 11.2779C14.2538 11.2107 14.3532 11.1479 14.4705 11.1018C14.5867 11.056 14.7091 11.0313 14.8109 11.031C15.1722 11.0388 15.533 11.0868 15.9282 11.1394C16.0847 11.1603 16.2466 11.1818 16.4161 11.2018C16.3442 11.8065 16.2722 12.4088 16.2002 13.0111C16.0243 14.4835 15.8483 15.9561 15.6723 17.4654C14.8755 17.37 14.0828 17.2747 13.2849 17.1786C12.048 17.0298 10.7985 16.8795 9.50206 16.7255C9.62117 16.5857 9.73849 16.4478 9.8543 16.3118C10.5959 15.4408 11.2754 14.6426 11.9627 13.8599Z"
											fill="#5D57E9"
											stroke="#5D57E9"
											stroke-width="0.3"
										/>
									</svg>
								</div>
								<div class="info">
									<p class="alias">{{ vit.vitamin }}</p>
									<p class="plate">
										Desde:
										<span>{{ vit.created_at | myGlobalDayShort }}</span>
									</p>
								</div>
							</div>
						</div>

						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 1)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 2)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 3)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 4)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 5)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 6)"
							/>
						</div>
						<div class="cell">
							<FeatherIcon
								class="text-primary"
								icon="CheckIcon"
								size="24"
								v-if="vit.days.some((d) => d == 7)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import TypeLineItem from "./TypeLineItem.vue"
import moment from "moment"
import preparacionService from "@/services/preparacion/default.service.js"

export default {
	name: "LineLife",
	components: {
		TypeLineItem,
	},
	props: {
		show: Boolean,
		specimen: Object,
		training_id: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			isActive: false,
			isLoading: false,
			lines: [],
			frequentVitamins: [],
			maxItems: 0,
			maxHeight: 0,
			page: 1,
			totalPages: 1,
			arrayPages: [],
			maxHeightContainer: 0,
		}
	},
	mounted() {},
	computed: {
		titleModal() {
			return this.show ? "Línea de tiempo de preparacion" : ""
		},
	},
	methods: {
		handleHidden() {
			this.isActive = false
			this.page = 1
			this.lines = []
			this.maxHeight = 0
			this.totalPages = 1
			this.arrayPages = []
			this.$emit("closing")
		},
		async init() {
			this.isPreloading()

			const {
				data: { data, last_page },
			} = await preparacionService.getTimeline({
				specimen_id: this.specimen.id,
				page: this.page,
				perpage: 7,
				training_id: this.training_id,
			})
			this.lines = data
			this.totalPages = last_page

			// generate arraypages
			this.arrayPages = Array.from({ length: this.totalPages }, (_, i) => i + 1)

			//impar
			const arrayImparesIndex = this.lines.filter((item, index) => index % 2 != 0)
			const maxItemsImpares = arrayImparesIndex.reduce((acc, item) => {
				if (item.actions.length > acc) {
					return item.actions.length
				}
				return acc
			}, 0)

			//par
			const arrayParesIndex = this.lines.filter((item, index) => index % 2 == 0)
			const maxItemsPares = arrayParesIndex.reduce((acc, item) => {
				if (item.actions.length > acc) {
					return item.actions.length
				}
				return acc
			}, 0)

			this.maxItems = this.lines.reduce((acc, item) => {
				if (item.actions.length > acc) {
					return item.actions.length
				}
				return acc
			}, 0)

			const maxH = maxItemsImpares * 60 + 10
			this.maxHeight = maxH > this.maxHeight ? maxH : this.maxHeight

			this.maxHeightContainer = (maxItemsImpares + maxItemsPares) * 60 + 120

			if (this.lines.length == 0) {
				this.maxHeight = 100
			}

			const { data: dataVitamins } = await preparacionService.getFrequentVitaminsByTraining({
				training_id: this.training_id,
				specimen_id: this.specimen.id,
			})

			this.frequentVitamins = dataVitamins

			this.isPreloading(false)
		},
		getDay(dateString) {
			moment.locale("es")
			return moment(dateString).format("MMM DD")
		},
		setPage(page) {
			this.page = page
			this.init()
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.isActive = val
				this.init()
			}
		},
	},
}
</script>

<style scoped lang="scss">
.container-line {
	min-width: 1200px;
	// min-width: 1400px;
	// overflow: hidden !important;
	// padding: 4rem 0;
	.container-scroll {
		// padding: 4rem;
		// padding-left: 4rem;
		// height: 500px;
		// min-width: 900px;
		display: flex;

		overflow: hidden;
		// align-items: center;
		overflow-y: auto !important;
		// overflow-x: auto;
		// background: red;
		// padding: 4rem 0 !important;
		@media screen and (min-width: 800px) {
			// overflow-x: hidden;
			// justify-content: center;
		}
		.line {
			// background: #17171a;
			// margin-left: 4rem;
			height: 20px;
			// background: var(--primary);
			// width: 2400px;
			width: 100%;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			position: relative;
			// border-radius: 160px !important;
			@media screen and (min-width: 800px) {
				width: 100%;
				min-width: 100%;
			}

			.day {
				// position: absolute;
				// top: 0;
				// left: 0;
				z-index: 200 !important;
				position: relative;
				.container-date {
					// background: red;
					position: relative;
					width: 100%;
					position: relative;
					z-index: 200 !important;
					// background: #fff;
					.circle {
						background: #fff !important;
						border: 4px solid var(--primary);
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						height: 40px;
						width: 40px;
						z-index: 300;
					}
					.day-text {
						font-size: 10px;
						font-weight: bolder;
						color: var(--primary);
						position: absolute;
						top: -20px;
						left: 0;
						width: 40px;
						display: flex;
						justify-content: center;
						p {
							// margin: 0;
							text-align: center;
							margin-bottom: 0;
						}
					}
					.day-text-bottom {
						position: absolute;
						top: 40px !important;
						left: 0;
						height: 21px;
					}
					.items {
						margin-top: 0.5rem;
						position: absolute;
						bottom: 100%;
						left: 0;
						margin-bottom: 1.5rem;
						// background: green;
						z-index: 100;
						// background: #fff;
					}
					.item-top {
						margin-bottom: 0;
						margin-top: 1.5rem;
						background: orange;
						// margin-top: 0;
						// position: absolute;
						top: 100%;
						// left: 0;
						// bottom: -200px;
					}
				}
				.line-vertical-line {
					position: absolute;
					top: 34px;
					left: 18.5px;
					// transform: translateX(-50%);
					z-index: 10;
					// height: 400px;
					width: 6px;
					border-left: 3px dotted var(--primary);
					// background: rgba($color: red, $alpha: 0.2);
				}
				.line-vertical-line-top {
					// background: green;
					bottom: 34px;
					top: auto;
				}
			}
			.circle-last {
				background: var(--primary);
				border-radius: 50%;
				width: 40px;
				height: 40px;
				z-index: 200;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.bars {
				background: var(--primary);
				height: 16px;
				width: 100%;
				z-index: 10;
				position: absolute;
				top: 12px;
				border-radius: 16px;
			}
			.first-specimen {
				width: 100px !important;
				position: relative;
				// margin-right: 100px;
				.container-specimen {
					position: absolute;
					top: -30px;
					left: 0;
					z-index: 200;
					text-align: center;
					img {
						border: 3px solid var(--primary);
						width: 100px;
						height: 100px;
						border-radius: 50%;
						object-fit: cover;
					}
					.info {
						.alias {
							color: var(--primary);
							font-weight: bolder;
							font-size: 20px;
							margin-bottom: 0;
							margin-top: 0.5rem;
							width: 100px;
						}
						.plate {
							margin-bottom: 0;
							color: #17171a;
							font-size: 16px;
							font-weight: 500;
							width: 100px;
						}
					}
				}
			}
		}
	}
}
.table-events-recurrent {
	min-width: 1200px;
	margin-bottom: 2rem;
	.container-days {
		display: grid;
		grid-template-columns: 1.5fr repeat(7, 1fr);
		// gap: 1rem;
		p {
			color: #323232;
			font-weight: bolder;
			font-size: 16px;
			border-left: 1px solid #5d57e9;
			text-align: center;
			border-top: 1px solid #5d57e9;
			padding: 0.5rem 0;
			// border-bottom: 1px solid #5d57e9;
			margin-bottom: 0;
			&:first-child {
				border-left: none;
				border-bottom: none;
				border-top: none;
			}
			&:nth-child(2) {
				border-top-left-radius: 12px;
			}
			&:last-child {
				border-top-right-radius: 12px;
				border-right: 1px solid #5d57e9;
			}
		}
	}
	.body-table {
		.container-events-recurrent {
			display: grid;
			grid-template-columns: 1.5fr repeat(7, 1fr);
			// gap: 1rem;
			.container-event {
				display: flex;
				padding: 0 0.5rem;
				// padding-bottom: 1rem;
				width: 96%;
				display: grid;
				grid-template-columns: 1fr 4fr;

				.circle {
					height: 42px !important;
					width: 42px !important;
					background: #cfcdff;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
				}
				.info {
					margin-left: 1rem;

					display: flex;
					flex-direction: column;
					// align-items: center;
					justify-content: center;
					// background: red;
					.alias {
						margin-bottom: 0;
						color: #323232;
						font-weight: bolder;
						font-size: 13px;
						line-height: 1;
					}
					.plate {
						font-size: 12px;
						margin-bottom: 0;
						color: #7c7c7c;
						span {
							font-weight: bolder;
						}
					}
				}
			}
			.cell {
				// border-bottom: 1px solid #5d57e9;
				border-left: 1px solid #5d57e9;
				border-top: 1px solid #5d57e9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0.5rem 0;
				&:first-child {
					border-top: 1px solid #5d57e9;
					// border-top-left-radius: 12px;
				}
				&:last-child {
					border-right: 1px solid #5d57e9;
				}
			}
			&:first-child {
				.cell {
					border-bottom: none;
					border-left: 1px solid #5d57e9;
					border-top: 1px solid #5d57e9;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 0.5rem 0;
					// background: red;
					&:first-child {
						// border-top: 1px solid #5d57e9;
						border-top-left-radius: 12px;
					}
					&:last-child {
						// border-right: 1px solid #5d57e9;
					}
				}
			}
			&:last-child {
				.cell {
					// background: red;
					border-bottom: 1px solid #5d57e9;
				}
			}
		}
	}
}

.container-btns {
	display: flex;
	align-items: center;
	justify-content: center;
	.pagination {
		margin-top: 1rem;
		border: 2px solid #d2dbe8;
		border-radius: 30px;
		position: relative;
		overflow: hidden;
		.pages {
			height: 30px;
			width: 30px;
			margin-bottom: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #404040;
			cursor: pointer;
		}
		.active {
			transition: 0.3s all ease-in-out;
			border-radius: 50%;
			height: 30px;
			width: 30px;
			position: absolute;
			background: var(--primary);
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 500;
		}
	}
}

.container-modal-line {
	overflow: auto;
}
</style>
